module.exports = __webpack_public_path__ + "img/empty.624890c1.svg";